import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ComponentPropsWithoutRef } from 'react';
import type React from 'react';
export const FilterCheckboxLabel: React.FC<ComponentPropsWithoutRef<'label'> & {
  /** The option returns nothing and is not chosen, so it is shown but not
   * offered: it keeps its count, loses the pointer and the hover. */
  disabled?: boolean;
}> = t0 => {
  const $ = _c(13);
  let children;
  let className;
  let disabled;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      disabled,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    props = $[4];
  }
  const t1 = disabled || undefined;
  const t2 = disabled ? "pointer-events-none cursor-default opacity-40" : "cursor-pointer hover:bg-brown-50";
  let t3;
  if ($[5] !== className || $[6] !== t2) {
    t3 = cx("-mx-2 flex items-center gap-2.5 rounded-lg px-2 py-1.5 transition select-none", t2, className);
    $[5] = className;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== props || $[10] !== t1 || $[11] !== t3) {
    t4 = <label {...props} aria-disabled={t1} className={t3}>{children}</label>;
    $[8] = children;
    $[9] = props;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export const FilterDrawerFieldLabel: React.FC<ComponentPropsWithoutRef<'span'>> = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cx("mb-1 block text-[11px] font-medium tracking-wide text-blue-400 uppercase", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <span {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const FilterDrawerCheckboxList: React.FC<ComponentPropsWithoutRef<'div'>> = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cx("flex flex-col gap-px", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div {...props} className={t1} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};